import viasport from '../provider/viasport';
import viaplay from '../provider/viaplay';

export default {
  viasport,
  viaplay,
};



// WEBPACK FOOTER //
// ./src/provider/index.js